import React, { useContext } from "react";

//Data
import popupDataBtn from "../../json/CreateCreditData/PopupBtnData.json";

//Components
import NavbarComponent from "../../components/NavbarComponent/NavbarComponent";
import SideMenusComponent from "../../components/SideMenusComponent/SideMenusComponent";
import CreateCreditRenovationBody from "../../components/CreateCreditRenovationBody/CreateCreditRenovationBody";
import LoadingScreenComponent from "../../components/LoadingScreenComponent/LoadingScreenComponent";
import NavbarMobile from "../../components/NavbarMobile/NavbarMobile";
import NavbarMobileBottom from "../../components/NavbarMobileBotton/NavbarMobileBottom";
import PopUpComponent from "../../components/PopUpComponent/PopUpComponent";
import VersionTxtComponent from "../../components/VersionTxtComponent/VersionTxtComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";
import { PopupContext } from "../../context/PopupContext";

const CreateCreditRenovationScreen = ({ userData, userMenuData }) => {
  const { loading } = useContext(LoadingContext);

  const { showPopup, popupData } = useContext(PopupContext);

  return (
    <>
      {loading && <LoadingScreenComponent />}
      {showPopup && (
        <PopUpComponent content={popupData} btnData={popupDataBtn.data[0]} userData={userData} />
      )}
      <div className="body-container">
        <VersionTxtComponent />
        <div className="body-subcontainer">
          <NavbarComponent userData={userData} />
          <NavbarMobile userData={userData} menuData={userMenuData} />
          <CreateCreditRenovationBody userData={userData} />
          <NavbarMobileBottom />
        </div>
        <SideMenusComponent menuData={userMenuData} />
      </div>
    </>
  );
};

export default CreateCreditRenovationScreen;
